import { HourglassIcon } from "../../icons";

const ProcessingStep = () => (
  <div className="flex h-full min-h-0 flex-col px-6 pt-4">
    <div className="flex flex-1 flex-col items-center justify-center gap-6">
      <div className="animate-hourglass">
        <HourglassIcon />
      </div>

      <div className="flex max-w-[337px] flex-col items-center gap-0 text-center">
        <p className="text-base font-semibold leading-7 text-text-primary">
          Processing
        </p>
        <p className="text-xs font-medium leading-[21px] text-text-secondary">
          please wait while we process your transaction. This will take no more
          than 30 seconds
        </p>
      </div>
    </div>
  </div>
);

export default ProcessingStep;
